module.exports = __webpack_public_path__ + "static/media/SWSCRC6-39.13aab38a.mp3";